import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { ChanelConfig } from '../../configs/GlobalConfig';
import userSettingService from '../../core/services/Common/UserSettingService';
import MessageHub from '../../core/signalr/SignalrMessageHub';
import Fingerprint2 from 'fingerprintjs2';
import {
  changeSyncComponentSearch,
  countDownSecondsToOpenMarket,
  getSecondsToOpenMarket,
  REDUCER_NAME,
  setTimeToOpenMarket,
} from '../app/commonReducer';

import ConstCommon from '../common/Const';
import ChangeLogsPopup from '../common/change-logs-popup';
import GuestPopup from '../common/guest-popup/GuestPopup';
import PopupWarning from '../common/popup-portal/popup-warning/PopupWarning';
import ConsensusAnalysis from '../fundamental/consensus-analysis/ConsensusAnalysis';
import EventEmitter, {
  SESSION_TIME_OUT,
  SET_ERROR,
  SHOW_GUEST_POPUP,
  SYNC_COMPONENT_SEARCH,
} from '../helpers/EventEmitter';
import MarketInDepth from '../market/market-in-depth';
import Watchlist from '../market/watchlist';
import TopVolume from '../market/top-mover/top-volume';
import TopValue from '../market/top-mover/top-value';
import TopBreakout from '../market/top-mover/top-breakout';
import TopGainers from '../market/top-mover/top-gainers';
import TopLosers from '../market/top-mover/top-losers';
import TopNewHigh from '../market/top-mover/top-new-high';
import TopNewLow from '../market/top-mover/top-new-low';
import TopForeignTrade from '../market/top-mover/top-foreign-trading';
import MoneyFlow from '../market/money-flow/MoneyFlow';
import MarketCalendar from '../market/market-calendar';
import HeatMap from '../market/heatmap/HeatMap';
import TimeAndSales from '../prices/time-and-sales';
import QuoteMovement from '../prices/quote-movement/';
import PriceData from '../prices/price-data/';
import PriceDepth from '../prices/price-depth';
import TASignals from '../technical/ta-signals/TASignals';
import Charting from '../technical/charting/Charting';
import Ownership from '../fundamental/ownership/Ownership';
import FinancialAnalysis from '../fundamental/financial-analysis';
import FADividendAnalysis from '../fundamental/dividend-analysis/FADividendAnalysis';
import FinancialStatement from '../fundamental/financial-statement/FinancialStatement';
import FASnapshot from '../fundamental/snapshot/FASnapshot';
import News from '../news-and-analysis/News';
import Valuation from '../tools/valuation/Valuation';
import STRanking from '../strategy/ranking/STRanking';
import Strategy from '../strategy/strategy/Strategy';
import Order from '../order/Order';
import FinancialRatio from '../fundamental/financial-ratio';

import LayoutHelper from '../helpers/Layout';
import GoldenLayoutWrapper from '../common/GoldenLayoutWrapper';
import MainLayout from './../main-layout';
import widgetConfig, { lockComponents } from './../../configs/WidgetConfig';
import Alerts from './../tools/alerts/index';
import Screener from './../tools/screener/Screener';
import { TradeData } from './../tools/trade-data';

import authProvider from './../../core/AuthenticationProvider';
import { setUserInfo } from '../app/reducer';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { positions, Provider as AlertProvider, transitions } from 'react-alert';
import AlertTemplate from '../common/alert-template';
import IntroModal from '../common/intro-modal';
import { SaveSystemSettingPopup } from './../main-layout/sidebar/save-system-setting';
import { ExcelPopup } from './../main-layout/sidebar/excel';
import AccountInfoPopup from './../main-layout/header/right/account-info-popup/AccountInfoPopup';
import PopupConfirmLogout from '../main-layout/header/right/popupConfirm/popupConfirmLogout';
import { saveLayout } from '../main-layout/sidebar/reducer';
import { isNotLoginOrExpired } from '../helpers/Common';
import { formatDate } from '../helpers/FormatDate';

const options = {
  timeout: 3000,
  position: positions.BOTTOM_LEFT,
  transitions: transitions.SCALE,
  containerStyle: {
    zIndex: 9999999,
    maxHeight: 435,
    display: 'flex',
    flexDirection: 'column-reverse',
    overflow: 'hidden',
  },
};

const objComponent = {
  MarketInDepth,
  Watchlist,
  TopVolume,
  TopValue,
  TopBreakout,
  TopGainers,
  TopLosers,
  TopNewHigh,
  TopNewLow,
  TopForeignTrade,
  MoneyFlow,
  MarketCalendar,
  HeatMap,
  TimeAndSales,
  QuoteMovement,
  PriceData,
  PriceDepth,
  TASignals,
  Charting,
  FinancialAnalysis,
  Ownership,
  FADividendAnalysis,
  FinancialStatement,
  FASnapshot,
  News,
  Alerts,
  Screener,
  ConsensusAnalysis,
  Valuation,
  STRanking,
  Strategy,
  TradeData,
  Order,
  FinancialRatio,
};

const mapComponentName = {
  'market-overview': ConstCommon.listComponent.MarketOverview,
  'stock-screener': ConstCommon.listComponent.StockScreener,
  'top-mover': ConstCommon.listComponent.TopMover,
  fundamental: ConstCommon.listComponent.Fundamental,
};

const IS_OTHER_LOGIN_KEY = 'IS_OTHER_LOGIN_KEY';

class DesktopWL extends Component {
  constructor(props) {
    super(props);

    this.listComponent = {};
    widgetConfig.forEach(({ list }) => {
      list.forEach(({ name }) => {
        this.listComponent[name] = React.createRef();
      });
    });
    this.componentName = this.getComponentName();
    this.timeouts = [];
    this.state = {
      isShowLoginPopup: !!localStorage.getItem(IS_OTHER_LOGIN_KEY),
      timeoutPopupSeconds: null,
      isShowTimeoutAPIPopup: false,
      changeLogs: null,
      errorText: '',
      isShowGuestPopup: false,
    };
  }

  componentDidMount() {
    this.registerComponents();
    const { setUserInfo } = this.props;
    authProvider.getUser().then(user => {
      if (user) {
        this.user = user;
        setUserInfo(user);
      }
    });
    this.setTimeToMarketOpen();
    MessageHub.subscribe(ChanelConfig.OtherLoginChannel, this.onOtherLogin);
    EventEmitter.subscribe(SESSION_TIME_OUT, this.onSessionTimeout);
    EventEmitter.subscribe(SET_ERROR, this.onReceiveError);
    this.getChangeLogs();
    EventEmitter.subscribe(SYNC_COMPONENT_SEARCH, this.onSearchSync);
    EventEmitter.subscribe(SHOW_GUEST_POPUP, this.onShowGuestPopup);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { timeOffset } = this.props;
    if (timeOffset !== null && timeOffset !== prevProps.timeOffset) {
      this.refreshComponent();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutSave);
    clearTimeout(this.tokenTimeoutId);
    this.timeouts.forEach(timeoutId => {
      clearTimeout(timeoutId);
    });
    clearTimeout(this.expiredTimeoutId);
    MessageHub.unsubscribe(ChanelConfig.OtherLoginChannel, this.onOtherLogin);
    EventEmitter.unsubscribe(SESSION_TIME_OUT, this.onSessionTimeout);
    EventEmitter.unsubscribe(SET_ERROR, this.onReceiveError);
    EventEmitter.unsubscribe(SYNC_COMPONENT_SEARCH, this.onSearchSync);
    EventEmitter.unsubscribe(SHOW_GUEST_POPUP, this.onShowGuestPopup);
  }

  getComponentName = () => {
    const { computedMatch } = this.props;
    return mapComponentName[computedMatch.params.name] || null;
  };

  registerComponents = async () => {
    const user = await authProvider.getUser();
    const listComponentTitle = I18n.t('common.listComponent');
    widgetConfig.forEach(({ list }) => {
      list.forEach(({ name }) => {
        const component = {
          name,
          component: objComponent[name],
          title: listComponentTitle[name],
          tooltip: listComponentTitle[name],
        };
        LayoutHelper.register(component);
        if (isNotLoginOrExpired(user) && lockComponents[name]) {
          return;
        }
        LayoutHelper.drag(this.listComponent[name].current, component);
      });
    });
  };

  onShowGuestPopup = () => {
    this.setState({ isShowGuestPopup: true });
  };

  onSearchSync = data => {
    const { changeSyncComponentSearch } = this.props;
    changeSyncComponentSearch(data);
  };

  getChangeLogs = () => {
    const isNotPopout = document.getElementById('root');
    if (isNotPopout) {
      var lastVersion = window.localStorage.getItem('fversion');
      if (!lastVersion) {
        lastVersion = '0.0.0.1';
      }

      userSettingService
        .getChangeLogsV3({ lastVersion: lastVersion })
        .then(({ items }) => {
          if (!items || (Array.isArray(items) && !items.length)) {
            return;
          }

          navigator.serviceWorker
            .getRegistrations()
            .then(function(registrations) {
              for (let registration of registrations) {
                registration.unregister();
              }
              window.localStorage.clear();
              window.localStorage.setItem('fversion', items[0].version);
              window.location.reload();
            });
          // this.setState({
          //   changeLogs: items,
          // });
        });
    }
  };

  onOtherLogin = data => {
    Fingerprint2.get(components => {
      var values = components.map(function(component) {
        return component.value;
      });
      var fp = Fingerprint2.x64hash128(values.join(''), 31);
      if (data !== fp) {
        localStorage.setItem(IS_OTHER_LOGIN_KEY, 'true');
        this.setState({
          isShowLoginPopup: true,
        });
      }
    });
  };

  onSessionTimeout = () => {
    if (this.expiredTimeoutId) {
      return;
    }
    const seconds = 60000;
    this.setState({ timeoutPopupSeconds: seconds });
    setInterval(() => {
      if (this.state.timeoutPopupSeconds === 0) {
        clearTimeout(this.expiredTimeoutId);
      }
      this.setState({
        timeoutPopupSeconds: this.state.timeoutPopupSeconds - 1000,
      });
    }, 1000);
    this.expiredTimeoutId = setTimeout(() => {
      window.location.href = '/';
    }, 60000);
  };

  setTimeToMarketOpen = () => {
    const { setTimeToOpenMarket, countDownSecondsToOpenMarket } = this.props;
    const now = new Date();
    const destTime = new Date();
    destTime.setHours(8, 30, 1, 0);
    const timeout = destTime.getTime() - now.getTime();
    if (timeout < 0) {
      return;
    }
    const timeoutId = setTimeout(() => {
      const seconds = getSecondsToOpenMarket();
      if (seconds === 0) {
        return;
      }
      setTimeToOpenMarket(seconds);
      countDownSecondsToOpenMarket();
    }, timeout);
    this.timeouts.push(timeoutId);
  };

  refreshComponent = () => {
    this.refreshAt(8, 30);
    this.refreshAt(8, 45);
    this.refreshAt(9, 2);
    this.refreshAt(9, 17);
    this.refreshAt(11, 32);
    this.refreshAt(13, 2);
    this.refreshAt(14, 47);
    this.refreshAt(15, 2);
  };

  refreshAt = (hour, minute) => {
    const { timeOffset } = this.props;
    const now = new Date();
    const destTime = new Date();
    destTime.setHours(hour, minute, 0, 0);
    destTime.setSeconds(destTime.getSeconds() + timeOffset);
    const timeout = destTime.getTime() - now.getTime();
    if (timeout < 0) {
      return;
    }

    const reloadId = setTimeout(() => {
      LayoutHelper.reload();
    }, timeout);
    this.timeouts.push(reloadId);
  };

  onOkClick = () => {
    localStorage.removeItem(IS_OTHER_LOGIN_KEY);
    authProvider.signout();
  };

  onOkClickSessionTimeout = () => {
    authProvider.signin();
  };

  hideChangeLogPopup = () => {
    this.setState({
      changeLogs: null,
    });
  };

  onReceiveError = text => {
    this.setState({
      errorText: text,
    });
  };

  onClickOkError = () => {
    this.setState({
      errorText: '',
    });
  };

  showGuestPopup = (bool = true) => {
    this.setState({
      isShowGuestPopup: bool,
    });
  };

  render() {
    const {
      isShowLoginPopup,
      timeoutPopupSeconds,
      changeLogs,
      errorText,
      isShowGuestPopup,
    } = this.state;
    return (
      <div className="container-fluid p-0">
        <div role="main" className="fiintrade-main">
          <GoldenLayoutWrapper
            {...this.listComponent}
            name={this.componentName}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  timeOffset: state[REDUCER_NAME].timeOffset,
});

const mapDispatchToProps = {
  setUserInfo,
  saveLayout,
  setTimeToOpenMarket,
  countDownSecondsToOpenMarket,
  changeSyncComponentSearch,
};

DesktopWL.propTypes = {
  setUserInfo: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DesktopWL);
